<mat-sidenav-container>
  <mat-sidenav #sidenav position="end">
    <mat-toolbar color="primary" class="mat-elevation-z1" *ngIf="authenticationService.userData">
      <mat-toolbar-row style="height: 100px" fxLayout="column" fxLayoutAlign="center center">
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-icon id="person-icon" color="black">person</mat-icon>
        </div>
      </mat-toolbar-row>
      <mat-toolbar-row fxLayout="column" fxLayoutAlign="center center">
        <h3>{{ authenticationService.userData.lastName }}</h3>
        <span style="font-size: 14px">{{ authenticationService.userData.fullNumber | phoneNumberFormatter }}</span>
        <!-- LANGUAGE SELECTOR -->
      </mat-toolbar-row>
      <mat-toolbar-row>
        <button mat-button (click)="logout()" class="logout-btn" fxFlex>
          <mat-icon inline="true">exit_to_app</mat-icon> {{ 'more.logout' | translate }}
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-nav-list>
      <ng-container *ngIf="desktopView">
        <ng-container *ngIf="hasAllOf([products.SWB_PRODUCT, products.ATTENDANT_ROLE]) | async">
          <ng-container *ngIf="newSwitchboardLink; else originalSwbLink">
            <a [href]="newSwitchboardLink" target="_swb_v6">
              <mat-list-item>
                <mat-icon>headset_mic</mat-icon>
                <a>{{ 'global.switchboard' | translate }}</a>
              </mat-list-item>
            </a>
          </ng-container>
          <ng-template #originalSwbLink>
            <mat-list-item
              [routerLink]="['swb']"
              routerLinkActive="active-link"
            >
              <mat-icon>headset_mic</mat-icon>
              <a>{{ 'global.switchboard' | translate }}</a>
            </mat-list-item>
          </ng-template>
        </ng-container>

        <mat-list-item [routerLink]="['sms']" routerLinkActive="active-link">
          <mat-icon>sms</mat-icon>
          <a>{{ 'global.sms' | translate }}</a>
        </mat-list-item>

        <mat-list-item
          *ngIf="hasAdmin && (hasOneOf([products.VPN_ADMINISTRATOR_ROLE, products.VPN_SERVICE_PROVIDER_ROLE]) | async)"
          [routerLink]="['admin']"
          routerLinkActive="active-link"
          queryParamsHandling="preserve"
        >
          <mat-icon>business</mat-icon>
          <a>{{ 'global.admin' | translate }}</a>
        </mat-list-item>

        <mat-list-item
          *ngIf="
            hasAdmin && !hasHideStatistics && (hasOneOf([products.VPN_ADMINISTRATOR_ROLE, products.VPN_SERVICE_PROVIDER_ROLE]) | async)
          "
          [routerLink]="['statistics']"
          routerLinkActive="active-link"
          queryParamsHandling="preserve"
        >
          <mat-icon>trending_up</mat-icon>
          <a>{{ 'global.statistics' | translate }}</a>
        </mat-list-item>

        <mat-list-item *ngIf="hasOneOf([products.WALLBOARD_PRODUCT]) | async" [routerLink]="['wallboard']" routerLinkActive="active-link">
          <mat-icon>tv</mat-icon>
          <a>{{ 'global.wallboard' | translate }}</a>
        </mat-list-item>

        <mat-list-item *ngIf="hasOneOf([products.CONFERENCE_PRODUCT]) | async" [routerLink]="['conference']" routerLinkActive="active-link">
          <mat-icon>call_split</mat-icon>
          <a>{{ 'global.conference' | translate }}</a>
        </mat-list-item>

        <mat-list-item
          *ngIf="
            (hasAllOf([products.VPN_SERVICE_PROVIDER_ROLE]) | async) ||
            ((hasAllOf([products.VPN_ADMINISTRATOR_ROLE]) | async) &&
              (hasOneOf([products.SWB_EXCHANGE_PRODUCT, products.SWB_DIRECTORY_PRODUCT, products.SWB_STATUS_SYNC]) | async))
          "
          [routerLink]="['mss']"
          routerLinkActive="active-link"
          queryParamsHandling="preserve"
        >
          <mat-icon>today</mat-icon>
          <a>{{ 'global.mss' | translate }}</a>
        </mat-list-item>

        <mat-list-item *ngIf="hasOneOf([products.WEBRTC_PRODUCT]) | async" [routerLink]="['phone']">
          <mat-icon>call</mat-icon>
          <a>{{ 'global.phone' | translate }}</a>
        </mat-list-item>

        <mat-list-item *ngIf="(hasOneOf([products.VPN_SERVICE_PROVIDER_ROLE]) | async) && hasServiceProvider" [routerLink]="['search']">
          <mat-icon>search</mat-icon>
          <a>{{ 'global.search' | translate }}</a>
        </mat-list-item>
      </ng-container>
      <mat-list-item (click)="sidenav.close()" [routerLink]="['user']" routerLinkActive="active-link" *ngIf="hasUserSettings">
        <mat-icon>person</mat-icon>
        <a>{{ 'global.my_settings' | translate }}</a>
      </mat-list-item>
      <mat-list-item
        *ngIf="newSwitchboardLink && (hasAllOf([products.SWB_PRODUCT, products.ATTENDANT_ROLE]) | async)"
        [routerLink]="['swb']"
        routerLinkActive="active-link"
      >
        <mat-icon>headset_mic</mat-icon>
        <a>{{ 'global.switchboard_old' | translate }}</a>
      </mat-list-item>
    </mat-nav-list>

    <h3 matSubheader id="languages-title">{{ 'global.languages' | translate }}</h3>
    <mat-nav-list>
      <mat-list-item *ngFor="let language of languages" (click)="setLanguage(language)">
        <mat-icon>language</mat-icon>
        <a>{{ language.local }}</a>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <mat-toolbar color="primary" fxLayout="row" fxLayoutGap="1em" class="mat-elevation-z4 main-toolbar" [ngClass]="{swb: isOnSwbPage}">
    <a fxFlex="0 0 auto" class="banner-logo" [routerLink]="['/']"></a>
    <div
      fxFlex="0 1 auto"
      class="org-name"
      *ngIf="managedOrganization | async as org"
      matTooltip="{{ 'admin.editing_organization' | translate: {name: org} }}"
    >
      {{ org }}
    </div>
    <span fxFlex="1 1 auto"></span>
    <gt-tab-menu></gt-tab-menu>
    <div fxFlex="0 0 auto" *ngIf="authenticationService.loggedIn" class="burger-button" fxLayout="column" fxLayoutAlign="center center">
      <button type="button" mat-icon-button (click)="sidenav.open()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <gt-breadcrumb *ngIf="showBreadcrumbs"></gt-breadcrumb>

  <div [ngClass]="showBreadcrumbs ? 'main-content-with-breadcrumbs' : 'main-content'">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>
